import React from "react";
import styled from "styled-components";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { StyledLabel, StyledRequired, Error, Hint } from "./styles";

const Container = styled.div`
    width: 100%;
`;

export const StyledInput = styled.input`
    color: hsl(0, 0%, 20%);
    width: 100%;
    border: 1px solid #9a9c9f;
    border-radius: 6px;
    padding: 9px;
    font-weight: 400;
    box-shadow: none;
    font-size: 16px;
    border-bottom: ${(props) => props.errorMessage && "2px solid #bd271e"};

    :focus-visible {
        outline: none;
        outline-style: none;
    }
    :disabled {
        border: none;
        background-color: transparent;
        padding: 0;
    }
`;
export const StyledInputWithBorder = styled.input`
    color: hsl(0, 0%, 20%);
    width: 100%;
    border: 1px solid #9a9c9f;
    border-radius: 6px;
    padding: 11px;
    font-weight: 400;
    box-shadow: none;
    font-size: 16px;
    :focus-visible {
        outline: none;
        outline-style: none;
    }
    :disabled {
        background-color: #80808024;
    }
    &.error {
        border-color: red;
    }
`;
const ErrorMessage = styled.p`
    color: #bd271e;
    font-weight: 400;
    font-size: 12px;
    margin-top: 4px;
`;
const InputContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;
const StyledWarningAmberOutlinedIcon = styled(WarningAmberOutlinedIcon)`
    color: #bd271e;
    width: 20px !important;
    height: 16px !important;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
`;
const ErrorLabel = styled(StyledLabel)`
    color: #bd271e;
`;
function Input({
    type,
    name,
    onChange,
    required,
    label,
    placeholder,
    value,
    max,
    min,
    error,
    isEditable,
    disableWithBorder,
    step,
    errorMessage,
    component,
}) {
    return (
        <Container>
            {label && (
                <>
                    {errorMessage ? (
                        <ErrorLabel>
                            {label} {required && <StyledRequired>*</StyledRequired>}
                        </ErrorLabel>
                    ) : (
                        <StyledLabel>
                            {label} {required && <StyledRequired>*</StyledRequired>}
                        </StyledLabel>
                    )}
                </>
            )}
            {!disableWithBorder && (
                <InputContainer>
                    {component}
                    <StyledInput
                        type={type}
                        name={name}
                        onChange={onChange}
                        required={required}
                        placeholder={placeholder}
                        value={value}
                        max={max || null}
                        min={min || null}
                        disabled={!isEditable}
                        step={step}
                        errorMessage={errorMessage}
                    />
                    {errorMessage && type !== "date" && <StyledWarningAmberOutlinedIcon />}
                </InputContainer>
            )}
            {disableWithBorder && (
                <InputContainer>
                    <StyledInputWithBorder
                        type={type}
                        name={name}
                        onChange={onChange}
                        required={required}
                        placeholder={placeholder}
                        value={value}
                        max={max || null}
                        min={min || null}
                        disabled={!isEditable}
                        className={error ? "error" : ""}
                        errorMessage={errorMessage}
                    />
                    {errorMessage && <StyledWarningAmberOutlinedIcon />}
                </InputContainer>
            )}
            <Hint>{error && required && <Error>please fill this field </Error>}</Hint>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </Container>
    );
}

export default Input;
